import { TableTopSummary } from 'src/components/table-top-summary';

export default TableTopSummary;
